.wrap {
  position: fixed;
  right: var(--sp-7);
  bottom: var(--sp-7);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  pointer-events: none;
}
.toast {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  max-width: 380px;
  padding: var(--sp-4) var(--sp-5);
  border: 1px solid var(--line2);
  border-left: 3px solid var(--status-success);
  border-radius: var(--radius-md);
  background: var(--surf);
  box-shadow: var(--shadow-md);
  color: var(--text);
  font-size: 11.5px;
  pointer-events: auto;
  animation: slide 0.2s ease;
}
.error {
  border-left-color: var(--magenta);
}
.warn {
  border-left-color: var(--amber);
}
.info {
  border-left-color: var(--aqua);
}
.icon {
  font-weight: 700;
}
.dismiss {
  margin-left: auto;
  border: none;
  background: none;
  color: var(--text2);
  cursor: pointer;
}
.dismiss:hover {
  color: var(--text);
}

@keyframes slide {
  from {
    opacity: 0;
    transform: translateX(16px);
  }
}
